export const getFileExtension = (filename?: string): string => {
  if (!filename) return "";
  const match = filename.match(/(\.[^.]+)$/);
  return match?.[1]?.replace(".", "").toUpperCase() ?? "";
};
